<template>
  <v-content>
    <v-card
      :width="cardWidth">
      <v-list>
        <v-list-tile class="tileTitle" avatar>
          <v-list-tile-avatar
            size=32
            tile>
            <img src="https://bunny.playposit.com/images/add_to_googleclassroom.png" alt="Google Classroom Logo">
          </v-list-tile-avatar>
          <v-list-tile-content>
            <v-list-tile-title>
              <span class="text-white text-truncate-popover">Playposit Google Classroom Assignment</span>
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
      <v-container
        class="mx-4">
        <v-layout
          row
          class="loaderRow"
          v-if="loadingData">
          <v-flex>
            <v-progress-linear
              indeterminate
              class="py-0 my-0"></v-progress-linear>
          </v-flex>
        </v-layout>
        <v-layout
          v-if="needsPermission"
          row>
          <v-flex>
            <h3 class="headline">Permissions Needed</h3>
            <p>You are launching a Playposit bulb from a Google Classroom class.  We need your permission to allow us to pass your grade from this bulb back to your teacher and Google Classroom class.<br/>If the Google login window doesn't open, check to make sure the pop-up wasn't blocked.</p>
          </v-flex>
        </v-layout>
        <v-layout
          v-else-if="!tokenSet"
          row>
          <v-flex>
            <h3 class="headline">Updating Permissions</h3>
            <p>We are updating your permissions in Playposit and will redirect you to the assignment shortly.</p>
          </v-flex>
        </v-layout>
        <v-layout
          v-else
          row>
          <v-flex>
            <h3 class="headline">{{tokenTitle}}</h3>
            <p>{{tokenMessage}}</p>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card>
  </v-content>
</template>

<script>
import { mapActions, mapMutations } from 'vuex';
import _ from 'lodash';
import Hashids from 'hashids';
const hashids = new Hashids('dachshund', 6, 'cdefhjkmnprtvwxy2345689');

export default {
  name: 'GoogleClassroomStudentSignIn',
  data() {
    return {
      cardWidth: '100%',
      loadingData: false,
      needsPermission: true,
      queryParams: null,
      tokenMessage: 'Permissions set successfully!  This window will close shortly.',
      tokenSet: false,
      tokenTitle: 'Permissions Set',
    };
  },
  methods: {
    ...mapMutations([
      'triggerSnackbar',
    ]),
    ...mapActions('learners', [
      'getGoogleAuthURL',
      'getStudentGoogleToken',
    ]),
    async launchGoogleAuthPage() {
      const authURL = await this.getGoogleAuthURL(`${window.location.href.split('?')[0]}`);
      const left = window.screenX + 1150;
      const top = window.screenY + 15;
      window.open(authURL.data, 'googleAuth', `width=700, height=900, top=${top}, left=${left}`);
    },
    async getStudentAccessToken(code) {
      try {
        this.loadingData = true;
        await this.getStudentGoogleToken(code);
        this.tokenSet = true;
        // send postMessage to redirect to Player
        window.opener.postMessage({
          type: 'playposit__learner_token_set',
          action: 'refresh',
        }, '*');
        setTimeout(() => {
          window.close();
        }, 5000);
      } catch(e) {
        this.tokenTitle = 'Permission Issue';
        this.tokenMessage = 'There was a potential problem setting your permissions. If you are in an incognito window, your permissions were set however, we can\'t refresh the page for you.  Please click the assignment link in your Google Classroom class to load into your assignment.  If you aren\'t in an incognito window please close this window and try again.  If the issue persists please contact help@playposit.com';
      } finally {
        this.loadingData = false;
      }
    },
    handleTokenMessageReceived(event) {
      if (event.data.type === 'playposit__learner_token_set') {
        const redirectURL = this.$route.contentType === 'bulb' ?
        `${window.location.origin}/player_v2/?type=bulb&bulb_id=${this.$route.query.contentId}&token=${this.$route.query.token}&section_id=${this.$route.query.sectionId}`
        : `${window.location.origin}/course/${hashids.encode([this.$route.query.contentId, this.$route.query.sectionId])}?token=${this.$route.query.token}`;
        window.location.replace(redirectURL);
      }
    },
  },
  beforeMount() {
    if (_.has(this.$route, 'query.token')) {
      this.cardWidth = "60%";
      this.launchGoogleAuthPage();
      window.addEventListener("message", this.handleTokenMessageReceived);
    } else if (_.has(this.$route, 'query.code')) {
      this.needsPermission = false;
      this.getStudentAccessToken({
        code: _.get(this.$route, 'query.code'),
      });
    }
  },
};
</script>

<style>
  .tileTitle {
    background-color: #2196F3;
  }
  .loaderRow {
    min-height: 25px;
  }
</style>
